<template>
  <div class="flex-row-center-center w-100" style="min-height: 200px">
    <div class="text-caption tableText--text">
      {{ $t("noData") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "NoRecord",
};
</script>
